// constants
import { showSuccessAlert } from "../../constants/alerts";
import { DevicesActionTypes } from "../devices/constants";

const INIT_STATE = {
  devices: [],
  pagination: null,
  loading: false,
  initialLoading: false,
  error: null,
};

interface DeviceActionType {
  type:
    | DevicesActionTypes.API_RESPONSE_SUCCESS
    | DevicesActionTypes.API_RESPONSE_ERROR
    | DevicesActionTypes.GET_DEVICES
    | DevicesActionTypes.ADD_DEVICES
    | DevicesActionTypes.DELETE_DEVICES
    | DevicesActionTypes.UPDATE_DEVICES
    | DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY
    | DevicesActionTypes.CLEAR_ERROR;
  payload: {
    actionType?: string;
    data?: any | {};
    error?: string;
    message?: string;
  };
}

const Devices = (state: any = INIT_STATE, action: DeviceActionType): any => {
  switch (action.type) {
    case DevicesActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case DevicesActionTypes.GET_DEVICES: {
          return {
            ...state,
            devices: action.payload.data?.boxes || action.payload.data,
            pagination: action.payload.data?.pagination || null,
            loading: false,
            initialLoading: false,
            error: null,
          };
        }

        case DevicesActionTypes.ADD_DEVICES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case DevicesActionTypes.UPDATE_DEVICES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case DevicesActionTypes.DELETE_DEVICES: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        case DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }

        default:
          return { ...state };
      }

    case DevicesActionTypes.API_RESPONSE_ERROR:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        initialLoading: false,
      };

    case DevicesActionTypes.GET_DEVICES:
    case DevicesActionTypes.ADD_DEVICES:
    case DevicesActionTypes.UPDATE_DEVICES:
    case DevicesActionTypes.DELETE_DEVICES:
    case DevicesActionTypes.UPDATE_DEVICES_AVAILABILTY:
      return { ...state, loading: true, initialLoading: true };

    case DevicesActionTypes.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return { ...state };
  }
};

export default Devices;
